import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { ArtistCard } from "../Cards/index";
import ChunkArray from "../../utils/ChunkArray";

class ArtistsGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAll: false
    };
  }

  onShowAllChange = () => {
    this.setState({
      showAll: !this.state.showAll
    });
  };

  renderShowMore() {
    const isShowMoreNecessary =
      this.props.artists &&
      this.props.limit &&
      this.props.artists.length > this.props.limitTo;

    if (!isShowMoreNecessary) {
      return <Fragment />;
    }
    return (
      <button
        onClick={this.onShowAllChange}
        className="text-center col-md-2 col-md-offset-5 col-xs-4 col-xs-offset-4 button bordered-tmp-button"
      >
        {!this.state.showAll ? "Ver todas" : "Ver menos"}
      </button>
    );
  }

  render() {
    let { artists } = this.props;

    if (!artists) {
      artists = [];
    }

    if (this.props.limit && !this.state.showAll) {
      artists = [...artists.slice(0, this.props.limitTo)];
    }

    const rows = ChunkArray(artists, 3);
    let count = 0;
    return (
      <div>
        <div className="row">
          {rows.map(row => {
            count += 1;

            return (
              <div key={count} className="row">
                {row.map(col => (
                  <ArtistCard key={col.id} artist={col} />
                ))}
              </div>
            );
          })}
        </div>
        {this.props.showMore && (
          <div className="row">{this.renderShowMore()}</div>
        )}
      </div>
    );
  }
}

ArtistsGrid.defaultProps = {
  limitTo: 3,
  limit: true,
  showMore: false
};

ArtistsGrid.propTypes = {
  limit: PropTypes.bool,
  limitTo: PropTypes.number,
  showMore: PropTypes.bool,
  artists: PropTypes.array.isRequired
};

export default ArtistsGrid;



// WEBPACK FOOTER //
// ./src/components/Artists/ArtistsGrid.js